import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { UserApi } from "service/api/user.api";
import { QUERY_KEYS } from "service/constant/query-keys";
import { downloadFileByUrl } from "ultis/common";

export const useGetListUser = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER_LIST, params],
    queryFn: async () => {
      const res = await UserApi.getListUser(params);
      return res.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useGetCountListUser = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER_LIST_COUNT, params],
    queryFn: async () => {
      const res = await UserApi.getListUserCount(params);
      return res.data.count;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useGetListRole = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER_ROLE_LIST, params],
    queryFn: async () => {
      const res = await UserApi.getListUserRole(params);
      return res.data?.[0]?.allowedRoles;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useBlockUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId) => UserApi.blockUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_LIST] });
      enqueueSnackbar("Khóa tài khoản thành công", { variant: "success" });
    },
  });
};

export const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => UserApi.createUser(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_LIST] });
      enqueueSnackbar("Tạo tài khoản thành công", { variant: "success" });
    },
  });
};

export const useEditUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => UserApi.editUser(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_LIST] });
      enqueueSnackbar("Sửa tài khoản thành công", { variant: "success" });
    },
  });
};

export const useExportListUser = (params, options) => {
  const newParams = {
    ...params,
    export: "export",
  };
  return useQuery({
    queryKey: [QUERY_KEYS.USER_LIST_EXPORT, newParams],
    queryFn: async () => {
      const res = await UserApi.getListUser(newParams);
      const linkFile = res.data?.fileUrl;
      if (linkFile) {
        downloadFileByUrl(linkFile);
      }
    },
    enabled: false,
    ...options,
  });
};
